import { useTableInfo, useTableInfoState } from '@/hooks/useTableInfo';
import { createContext } from 'react';
export const TableInfoContext = createContext({} as useTableInfoState);
const { Provider } = TableInfoContext;
type TableInfoProviderProps = {
    children: JSX.Element;
    hostId: number;
};
export const TableInfoProvider = ({
    children,
    hostId,
}: TableInfoProviderProps) => {
    const tb = useTableInfo(hostId);
    return <Provider value={tb}>{children}</Provider>;
};
